export function getSpanishLanguage() {
    return {
        orderMulti: false,
        decimal: '.',
        thousands: ',',
        info: 'Mostrando _START_ a _END_ de _TOTAL_ registros',
        infoEmpty: 'Mostrando 0 a 0 de 0 registros',
        infoFiltered: '(filtrado de _MAX_ registros en total)',
        infoPostFix: '',
        lengthMenu: 'Mostrar _MENU_ registros',
        loadingRecords: '<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Cargando...</span></div>',
        processing: '<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Procesando...</span></div>',
        search: 'Buscar:',
        zeroRecords: 'No se encontraron resultados',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
            first: 'Primero',
            previous: 'Anterior',
            next: 'Siguiente',
            last: 'Último'
        },
        aria: {
            sortAscending: ': activar para ordenar la columna de manera ascendente',
            sortDescending: ': activar para ordenar la columna de manera descendente'
        },
        buttons: {
            copy: 'Copiar',
            colvis: 'Visibilidad de columnas'
        }
    };
}
